// extracted by mini-css-extract-plugin
export default {"signInStatusContainer":"Auth_signInStatusContainer__4+rG2","linkButton":"Auth_linkButton__Aet6S"};